export type TContactAvatar = {
    style: string;
    seed: string;
};

export const getContactVariants = (color: string) => {
    const hex = color
        .match(/\d+/g)
        .map((x) => Number(x).toString(16).padStart(2, '0'))
        .join('');

    const accesories = '&accessoriesProbability=0';
    const facialHair = '&facialHairProbability=0';
    const eyes = '&eyesVariant=squint';
    const backgroundColor = `&backgroundColor=${hex}`;
    const mouth = '&mouthVariant=twinkle';
    const hair =
        '&topVariant=bigHair,bob,bun,curly,curvy,dreads,dreads01,dreads02,frizzle,fro,longButNotTooLong,miaWallace,shaggy,shaggyMullet,shavedSides,shortCurly,shortFlat,shortRound,shortWaved,sides,straight01,straight02,straightAndStrand,theCaesar,theCaesarAndSidePart';
    const eyebrows =
        '&eyebrowsVariant=default,defaultNatural,flatNatural,raisedExcitedNatural';
    return (
        accesories +
        facialHair +
        eyes +
        backgroundColor +
        mouth +
        hair +
        eyebrows
    );
};

export const CONTACT_DEFAULT_AVATAR = {
    style: 'avataaars',
    seed: 'warbox-a90',
};

export const CONTACT_AVATARS = [
    //Women
    {
        style: 'avataaars',
        seed: 'warbox-a90',
    },
    {
        style: 'avataaars',
        seed: 'warbox-sa50k',
    },
    {
        style: 'avataaars',
        seed: 'warbox-19mlg',
    },
    {
        style: 'avataaars',
        seed: 'warbox-19mlm',
    },
    {
        style: 'avataaars',
        seed: 'warbox-06',
    },
    {
        style: 'avataaars',
        seed: 'warbox-90as',
    },

    //Men
    {
        style: 'avataaars',
        seed: 'warbox-21mlm',
    },

    {
        style: 'avataaars',
        seed: 'warbox-cakl',
    },
    {
        style: 'avataaars',
        seed: 'warbox-908',
    },
    {
        style: 'avataaars',
        seed: 'warbox-0a0hf',
    },
    {
        style: 'avataaars',
        seed: 'warbox-aasja',
    },
    {
        style: 'avataaars',
        seed: 'warbox-001',
    },
];
